export default "__VITE_ASSET__BCpUP2Na__"